import type { ReturnRequestDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";

interface UseEditShippingAddressParams {
	onSuccess: (returnRequest: ReturnRequestDto) => void;
}

export default function useEditShippingAddress(
	params: UseEditShippingAddressParams,
) {
	return useApiMutation(
		"patch",
		"/shops/{shopId}/return-requests/{returnRequestId}/shipping-address",
		{
			onSuccess: (returnRequest: ReturnRequestDto) => {
				params.onSuccess(returnRequest);
			},
		},
	);
}
